import React, { Fragment } from 'react';
import { Col, Container, Row } from 'reactstrap';
import LoginForm from './LoginForm';
import imgg from '../../../assets/logo-qeza-care-color-swapped.jpg';
import { useSelector } from 'react-redux';
import { H5, Spinner } from '../../../AbstractElements';

const LoginOne = () => {
    const isLoading = useSelector((state) => state.auth.loading);

    return (
        <Fragment>
            {isLoading && 
                <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(62, 62, 62, 0.5)', zIndex: 9999 }}>
                    <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
                        <div className="loader-box">
                            <Spinner attrSpinner={{ className: 'loader-30', style: { width: '80px', height: '80px', border: '4px solid rgba(255, 255, 255, 0.3)', borderTop: '4px solid #fff' } }} />
                        </div>
                        <H5 attrH5={{ className: 'sub-title mb-0 text-center', style: { color: '#fff' } }}>Loading...</H5>
                    </div>
                </div>
            }
            <Container fluid={true}>
                <Row>
                    <Col xl="7" style={{ backgroundImage: `url(${imgg})`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover', backgroundPosition: 'center', display: 'block' }} >
                    </Col>
                    <Col xl="5 p-0">
                        <LoginForm />
                    </Col>
                </Row>
            </Container>
        </Fragment>
    );
};

export default LoginOne;